import { Drawer, Row, Col } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import Close from "../../assets/images/close-x.svg";
import DefaultProductImage from "../../assets/images/no-image.svg";
import data from "../../constants/retailPos.json";

const SearchedProductsDrawer = ({
  searchedProductsFlag,
  setSearchedProductsFlag,
  searchedProductsDrawerData,
  currenciesList,
  handleAddSearchedProduct,
}) => {
  return (
    <Drawer
      closable={false}
      placement="bottom"
      open={searchedProductsFlag}
      closeIcon={null}
      maskClosable={false}
      className="filter"
      styles={{ body: { paddingBottom: 0, paddingTop: 0 } }}
      onClose={() => setSearchedProductsFlag(false)}
      height="85vh"
      title={
        <div style={{ position: "relative", padding: "1vh 1vw" }}>
          <img
            src={Close}
            style={{
              width: "1.5vw",
              position: "absolute",
              top: "2vh",
              right: "0.2vw",
              cursor: "pointer",
            }}
            onClick={() => setSearchedProductsFlag(false)}
            alt="Close"
          />
        </div>
      }
    >
      <Scrollbars className="productionScroll">
        {searchedProductsDrawerData?.map((product) => {
          return (
            <Row
              key={product?.m_product_id}
              gutter={[15, 11]}
              style={{ width: "98%", backgroundColor: "#fff", marginTop: "2.5vh", height: "13vh", marginLeft: "1vw", borderRadius: "10px" }}
            >
              <Col span={4}>
                <img
                  style={{
                    width: "100%",
                    height: "11vh",
                    objectFit: "contain",
                    borderRadius: "5px",
                    marginTop: "1vh",
                    display: "flex",
                    alignItems: "center",
                  }}
                  src={product.imageurl ? product.imageurl : DefaultProductImage}
                  alt=""
                />
              </Col>
              <Col span={16}>
                <div style={{ maxWidth: "100%", overflow: "hidden", paddingTop: "1vh" }}>
                  <label
                    style={{ ...data.posScreenStyles.productsCard.cardDetails.productDescr, whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                    className="productName"
                  ></label>
                </div>
                <p style={data.posScreenStyles.productsCard.cardDetails.superMarketProd} className="productName">
                  {`${product?.product_name} - ${product?.product_value}`}
                  <span style={{ display: "block" }}>{`Stock Qty - ${product?.stock ? product?.stock : 0}`}</span>
                </p>
              </Col>
              <Col span={4} style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                <span className="productDescription-kiosk">
                  {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                  {product?.sale_price ? product?.sale_price : 0}
                  <span style={{ marginLeft: "2px", marginTop: 0 }}>{currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}</span> / {product?.uomname}
                </span>
                <span
                  style={{ fontSize: "0.8em", color: "#fff", backgroundColor: "#2F3856", padding: "1vh 2.5vw", marginTop: "2%", borderRadius: "3px", cursor: "pointer" }}
                  onClick={handleAddSearchedProduct(product)}
                >
                  ADD
                </span>
              </Col>
              <span tabIndex={0}></span>
            </Row>
          );
        })}
      </Scrollbars>
    </Drawer>
  );
};

export default SearchedProductsDrawer;
